import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { HubIssue } from '../types/hubissue';
import { IssueAction } from '../types/issue-action';
import { IssueActionType } from '../types/issue-action-type';
import { IssueStatus } from '../types/issue-status';

@Component({
  selector: 'issue-actions',
  templateUrl: './issue-actions.component.html',
  styleUrls: ['./issue-actions.component.css'],
  providers: [HubService],
})


export class IssueActionsComponent implements OnInit {
  @Input() hub: Hub;
  @Input() issue: HubIssue;
  @Input() issue_statuses = <IssueStatus[]>[];
  @Input() action_types = <IssueActionType[]>[];
  @Output() action_saved = new EventEmitter<boolean>();
  actionCount = 0;
  actions = <IssueAction[]>[];
  errorMessage: string;
  current_action = 'none';

  private resolve_action: IssueAction;
  private defer_action: IssueAction;
  private note_action: IssueAction;
  private escalate_action: IssueAction;
  private note_issue_status: number;
  private deferred_action_due: string;
  private escalate_action_due: string;
  action_took_minutes: number;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('IssueActionsComponent Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.refresh();
  }

  updateActions(actions: IssueAction[]): void {
    // console.log('Got new actions: ' + JSON.stringify(actions, null, 2));
    this.actionCount = actions.length;
    this.actions = actions;
  }

  getColorFor(action: IssueAction): string {
    try {
      if (this.errorMessage) { return '#ff8080'; } // So editor doesn't make me think this can be static
    } catch (e) {}
    return '#EEEEEE';
  }

  refresh(): void {
    // console.log('Fetching actions for issue ' + JSON.stringify(this.issue, null, 2));
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getIssueActions(this.issue.issue_id))
    ).subscribe(
      issue_actions => this.updateActions(issue_actions),
      err => IssueActionsComponent.handleRefreshError(err)
    );
  }


  NewAction(type: number): IssueAction {
    let action = new IssueAction();
    action.issue_id = this.issue.issue_id;
    action.action_type = type;
    return action;
  }

  noteAction(): void {
    document.getElementById('new_action').style.display = 'block';
    this.note_action = this.NewAction(IssueActionType.Other);
    this.note_issue_status = this.issue.status;
    this.current_action = 'note';
  }

  resolveAction(): void {
    document.getElementById('new_action').style.display = 'block';
    this.resolve_action = this.NewAction(IssueActionType.Resolve);
    this.current_action = 'resolve';
  }

  resolveDuplicateAction(): void {
    document.getElementById('new_action').style.display = 'block';
    this.resolve_action = this.NewAction(IssueActionType.ResolveDuplicate);
    this.current_action = 'duplicate';
  }

  deferAction(): void {
    document.getElementById('new_action').style.display = 'block';
    this.defer_action = this.NewAction(IssueActionType.Defer);
    let default_defer = Date.now() + 86400 * 2000;
    this.deferred_action_due = new Date(default_defer).toISOString();
    this.current_action = 'defer';
  }

  escalateAction(): void {
    document.getElementById('new_action').style.display = 'block';
    this.escalate_action = this.NewAction(IssueActionType.Escalate);
    let default_escalate = Date.now() + 86400 * 9000;
    this.escalate_action_due = new Date(default_escalate).toISOString();
    this.current_action = 'escalate';
  }

  saveIssue(new_issue: HubIssue, new_action: IssueAction): void {
    let actionToSave = Object.assign({}, new_action);  // Clone
    let thisComponent = this;
    new_issue.last_action = new Date().toISOString();
    console.log('Writing issue: ' + JSON.stringify(new_issue, null, 2));
    this.hubService.writeIssue(new_issue)
      .subscribe(function() {
        console.log('Wrote issue, now writing action: ' + JSON.stringify(actionToSave, null, 2));
        thisComponent.saveAction(actionToSave);
      });
  }

  saveAction(new_action: IssueAction): void {
    new_action.took_minutes = +this.action_took_minutes;
    new_action.user_profile_id = AppComponent.GetUserProfile().id;
    new_action.user_profile_type = AppComponent.GetUserProfile().type;
    this.hubService.writeIssueAction(new_action)
      .subscribe(() => {
        this.action_saved.emit(true);
        this.refresh();
      });
  }

  saveNote(): void {
    let new_issue = this.issue;
    new_issue.status = this.note_issue_status;
    this.saveIssue(new_issue, this.note_action);
  }

  saveResolution(): void {
    let new_issue = this.issue;
    new_issue.status = IssueStatus.Resolved;
    this.saveIssue(new_issue, this.resolve_action);
  }

  saveDuplicateResolution(): void {
    let new_issue = this.issue;
    new_issue.status = IssueStatus.ResolvedDuplicate;
    this.saveIssue(new_issue, this.resolve_action);
  }

  saveDeferrment(): void {
    let new_issue = this.issue;
    new_issue.status = IssueStatus.Deferred;
    new_issue.action_due = this.deferred_action_due;
    this.saveIssue(new_issue, this.defer_action);
  }
  saveEscalation(): void {
    let new_issue = this.issue;
    new_issue.status = IssueStatus.Escalated;
    new_issue.action_due = this.escalate_action_due;
    this.saveIssue(new_issue, this.escalate_action);
  }
}

